import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IPurchaseOrderInvoice } from '../purchase-order-invoice.interface';
import { PurchaseOrderInvoiceService } from '../purchase-order-invoice.service';

@Component({
  templateUrl: './purchase-order-invoice-detail.component.html',
  selector: 'pg-purchase-order-invoice-detail'
})
export class PurchaseOrderInvoiceDetailComponent extends TableActionsTemplate {
  visible = true;
  @Input() dataDocument: any;
  @Output() onHideData = new EventEmitter<boolean>();
  tableDetailSettings: ISettingsTable;
  detailPurchaseOrder;
  prueba: any[];
  precioTotal = 0;
  quantity = 0;
  quantityReceived = 0;
  constructor(private serviceBase: PurchaseOrderInvoiceService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Detalle de los Productos',
      columns: [
        { header: 'Producto', field: 'name' },
        { header: 'Cantidad', field: 'quantity' }
      ]
    };
    this.initSubscriptions$();
    this.visible = true;
  }
  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrderInvoice[]) => {
        const id = data.findIndex(
          (item) => item['id'] == this.dataDocument['id']
        );
        this.table.data = data[id]['products'];
        this.detailPurchaseOrder = data[id];
        this.calcularCantidadFacturada();
      });
  }
  calcularCantidadFacturada() {
    this.quantity = 0;
    for (const item of this.detailPurchaseOrder['products']) {
      this.quantity += Number(item['quantity']);
    }
  }

  onHideDataDialog() {
    this.visible = false;
    this.onHideData.emit();
  }
}
